module.exports = __webpack_public_path__ + "media/background3.0ea63eb0.mp4";